export const LANGUAGES = {
  PYTHON: {
    NAME: 'Python',
    ACE_NAME: 'python',
  },
  JAVASCRIPT: {
    NAME: 'NodeJS',
    ACE_NAME: 'javascript',
  },
};

export const FREE_USER_TIERS = ['FREE', 'FREE_TRIAL'];
